/* eslint-disable angular/file-name */
angular.module('zc.core')

  .component('zcMonthChooser', {
  // <zc-month-chooser> assumes that the month is handled by $stateParams
  // and the state parameter's format should be 'YYYY-MM'
    templateUrl: '/templates/core/components/month_chooser/month_chooser.html',
    bindings: {
    // stateParam can be used to overwrite which $stateParam is used.
    // Default value is 'month'
      stateParam: '@',
      // minDate should be date and can be any day of month.
      // If it's for example 2016-09-15, 2016-09 will be allowed month
      minDate: '<'
    },
    controller: monthChooserController,
  });

monthChooserController.$inject = ['$location', '$state', '$stateParams'];
function monthChooserController($location, $state, $stateParams) {
  const vm = this;
  const currentState = $state.current.name;

  // variables
  vm.$state = $state;

  // actions
  vm.goToNext = goToNext;
  vm.goToPrev = goToPrev;

  this.$onInit = () => {
    vm.currentMonth = moment(getStateParam(), 'YYYY-MM' ).toDate();

    if(nextMonthExists()) {
      vm.nextMonth = moment(getStateParam(), 'YYYY-MM').add(1, 'month').format('YYYY-MM');
    } else {
      vm.nextMonth = null;
    }

    if(prevMonthExists()) {
      vm.prevMonth = moment(getStateParam(), 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
    } else {
      vm.prevMonth = null;
    }
  };

  function goToNext() {
    if(nextMonthExists()) {
      $state.go(currentState, getNextMonthParams());
    }
  }

  function goToPrev() {
    if(prevMonthExists()) {
      $state.go(currentState, getPrevMonthParams());
    }
  }

  function nextMonthExists() {
    const currentParamMonth = moment(getStateParam(), 'YYYY-MM').startOf('month');
    const currentMonth = moment().startOf('month');
    if(moment(currentParamMonth).isAfter(currentMonth) ||
        moment(currentParamMonth).isSame(currentMonth)) {
      return false;
    }
    return true;
  }

  function prevMonthExists() {
    if(!vm.minDate) return true;

    const currentParamMonth = moment(getStateParam(), 'YYYY-MM').startOf('month');
    const minMonth = moment(vm.minDate).startOf('month');
    if(moment(currentParamMonth).isBefore(minMonth) ||
        moment(currentParamMonth).isSame(minMonth)) {
      return false;
    }
    return true;
  }

  function getNextMonthParams() {
    const newParams = {};
    newParams[getParamName()] = vm.nextMonth;
    return _.merge({}, $stateParams, newParams);
  }

  function getPrevMonthParams() {
    const newParams = {};
    newParams[getParamName()] = vm.prevMonth;
    return _.merge({}, $stateParams, newParams);
  }

  function getParamName() {
    return vm.stateParam || 'month';
  }

  function getStateParam() {
    return $stateParams[getParamName()];
  }

}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/month_chooser/month_chooser.js